import { ElementRef, Renderer2, RendererFactory2 } from '@angular/core';
import { StaticFileUrlService } from 'Angular/services/static-file-url.service';
// We need to import svgxuse so that our external loading of SVGs works with Mobile Safari.
import 'svgxuse';
import * as i0 from "@angular/core";
import * as i1 from "Angular/services/static-file-url.service";
/**
 *
 * Image Directive
 *
 * Displays an image
 *
 * Input Properties:
 *
 *  imageSrc: The location of the image file in its app's static folder (e.g. "integrations/images/black-diamond-logo.png")
 *
 */
export class ImageDirective {
    constructor(el, rendererFactory, staticFileUrlService) {
        this.el = el;
        this.rendererFactory = rendererFactory;
        this.staticFileUrlService = staticFileUrlService;
        this.renderer = rendererFactory.createRenderer(null, null);
    }
    ngOnInit() {
        this.renderer.addClass(this.el.nativeElement, this.imageSrc);
        this.staticFileUrlService.getAbsoluteURL(this.imageSrc).subscribe((url) => {
            this.renderer.setAttribute(this.el.nativeElement, 'src', url);
        });
    }
}
ImageDirective.ɵfac = function ImageDirective_Factory(__ngFactoryType__) { return new (__ngFactoryType__ || ImageDirective)(i0.ɵɵdirectiveInject(i0.ElementRef), i0.ɵɵdirectiveInject(i0.RendererFactory2), i0.ɵɵdirectiveInject(i1.StaticFileUrlService)); };
ImageDirective.ɵdir = /*@__PURE__*/ i0.ɵɵdefineDirective({ type: ImageDirective, selectors: [["img", "ycnImage", ""]], inputs: { imageSrc: "imageSrc" }, standalone: false });
